import { Crosshair, Move3d, Trash2 } from "lucide-react";
import { CAPTION_MOTIONS } from "@/lib/motion";

// Caption motion: float / shake, ride the video's camera move, or follow a tracked object.
export const CaptionMotionControl = ({ obj, onPatch, onTrack }) => {
  const m = obj.motion || { type: "none" };
  const setM = (patch) => { const n = { intensity: 0.6, ...m, ...patch }; onPatch({ motion: n.type === "none" ? null : n }); };
  return (
    <div className="flex w-full flex-wrap items-center gap-2 rounded-lg border border-white/10 bg-white/[0.02] p-2.5" data-testid="caption-motion">
      <span className="flex items-center gap-1 text-[10px] font-bold uppercase tracking-wide text-[#A1A1AA]"><Move3d size={11} className="text-[#30D158]" /> Motion</span>
      <select value={m.type || "none"} onChange={(e) => setM({ type: e.target.value })} data-testid="caption-motion-type"
        className="rounded border border-white/10 bg-white/[0.03] px-2 py-1 text-xs text-white outline-none">
        {CAPTION_MOTIONS.map(([v, l]) => <option key={v} value={v} className="bg-[#141414]">{l}</option>)}
      </select>
      {m.type && m.type !== "none" && (
        <input type="range" min="0" max="1" step="0.05" value={m.intensity ?? 0.6} onChange={(e) => setM({ intensity: +e.target.value })}
          data-testid="caption-motion-intensity" title="Strength" className="w-16 accent-[#30D158]" />
      )}
      <label className="flex items-center gap-1 text-xs text-[#A1A1AA]" title="Caption rides the video's camera move so it looks placed in the scene">
        <input type="checkbox" checked={!!obj.stick} onChange={(e) => onPatch({ stick: e.target.checked })} data-testid="caption-stick-camera" className="accent-[#30D158]" /> Move with camera
      </label>
      {obj.track ? (
        <button onClick={() => onPatch({ track: null })} data-testid="caption-track-remove" className="flex items-center gap-1 rounded-lg border border-white/15 px-2 py-1 text-xs text-[#A1A1AA] hover:text-red-400"><Trash2 size={12} /> Remove tracking</button>
      ) : onTrack && (
        <button onClick={onTrack} data-testid="caption-track-btn" className="flex items-center gap-1 rounded-lg border border-[#FFC94D]/50 px-2 py-1 text-xs font-semibold text-[#FFC94D] hover:bg-[#FFC94D]/10"><Crosshair size={12} /> Track object</button>
      )}
      {obj.track && <span className="text-[10px] text-[#30D158]" data-testid="caption-track-status">Following object · {obj.track.pts?.length || 0} points</span>}
    </div>
  );
};
